import React, { Component } from 'react';
import './map-demo.css';
import mapboxgl from 'mapbox-gl';
import Mapir from 'mapir-react-component';
import axios from 'axios';
import {
  MapDemoContext,
  AddressBar,
  Sidebar,
  Input,
  Button,
  MessageBox,
} from '..';
import URL from './../../URL';
import { mapApiKey } from './../../config';
import defaultMarkerBlue from './../../assets/img/default-marker-blue.svg';
import defaultMarker from './../../assets/img/default-marker.svg';
import skip from './../../assets/img/skip.svg';
import close from './../../assets/img/close_white.svg';
import Joyride, { CallBackProps, STATUS } from 'react-joyride/lib';

const Map = Mapir.setToken({
  transformRequest: (url) => {
    return {
      url: url,
      headers: {
        'x-api-key': mapApiKey, //Mapir api key
        'Mapir-SDK': 'reactjs',
      },
    };
  },
});

let lastCenter = [];
let flag = false;

export default class MapDemo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: {},
      zoom: [10],
      address: '',
      routes: '',
      lineColors: [],
      searchInput: null,
      searchResult: [],
      searchTimeOut: undefined,
      popup: [],
      adressBarLocation: [],
      steps: [
        {
          target: '#show-demo-tour',
          content: (
            <div>
              <p>
                برای استفاده روان از بزارهای نقشه آموزش کاربردی آن‌ها را مشاهده
                کنید.
              </p>
              <br />
              <p>
                هر زمان که به مشاهده دوباره آموزش نیاز داشتید از این گزینه
                استفاده کنید.
              </p>
            </div>
          ),
          disableBeacon: true,
          placement: 'bottom-start',
          locale: { close: 'مشاهده آموزش', skip: 'بستن آموزش' },
          styles: {
            tooltip: {
              flexDirection: 'column',
              padding: 30,
            },
            tooltipContent: {
              padding: '0 0',
            },
            tooltipFooter: {
              justifyContent: 'space-between',
            },
            options: {
              width: 380,
            },
            buttonNext: {
              backgroundColor: 'unset',
              backgroundImage: 'unset',
              backgroundSize: 'unset',
              backgroundRepeat: 'unset',
              backgroundPosition: 'unset',
              width: 146,
              borderColor: 'white',
              borderStyle: 'solid',
              borderWidth: 3,
              borderRadius: 20,
              margin: '0 10px',
            },
            buttonSkip: {
              backgroundImage: 'unset',
              backgroundSize: 'unset',
              backgroundRepeat: 'unset',
              backgroundPosition: 'unset',
              width: 146,
              borderColor: 'white',
              borderStyle: 'solid',
              borderWidth: 3,
              borderRadius: 20,
              padding: 8,
              margin: '0 10px',
            },
          },
        },
        {
          target: '.icon-remark',
          content: 'برای انتخاب نقطه روی نقشه از اینجا شروع کنید.',
          disableBeacon: true,
          placement: 'left',
        },
        {
          target: '.icon-setmark',
          content: 'برای تایید نقطه موردنظر از این گزینه استفاده کنید.',
          disableBeacon: true,
          placement: 'left',
        },
        {
          target: '.longitude .input-primary',
          content:
            'در این قسمت مختصات مورد نظر را کنترل کنید یا مختصات دلخواه وارد نمایید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.close-wrapper',
          content: 'در این قسمت آدرس مورد نظر را کنترل کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.input-primary.destination-name',
          content: 'نام مقصد را مشحص کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.time-window .input-primary',
          content: 'زمان توقف در هر مقصد را وارد کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.main-bar .submit',
          content: 'مقصد موردنظر خود را ثبت کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.sidebar-wrapper',
          content: 'در این قسمت اطلاعات هر مقصد را به تفکیک مشاهده می‌کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.item-option-more',
          content: 'از این قسمت اطلاعات هر مقصد را ویرایش یا آن را حذف کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.item-option-chackbox:nth-child(1)',
          content: 'با استفاده از این گزینه مبدا مسیریابی‌را مشخص کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.options-wrapper .options-item input[name="roundtrip"]',
          content:
            'مشخص کنید که لازم است پس از تمامی مقصد‌ها به مبدا بازگشت یا خیر.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.options-wrapper .options-item  input[name="capacity"]',
          content:
            'با استفاده از این گزینه حجم بار تحویلی هر مقصد را مشخص نمایید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.options-wrapper .options-item  input[name="timewindow"]',
          content:
            'با استفاده از این گزینه پنجره زمانی تحویل بار هر مقصد را مشخص نمایید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.submit-wrapper .submit',
          content:
            'پس از انتخاب حداقل سه نقطه می‌توانید مسیریابی را آغاز کنید.',
          disableBeacon: true,
          placement: 'top-start',
        },
        {
          target: '.icon-search',
          content:
            'همچنین، با استفاده از گزینه جستجو می‌توانید مقاصد مورد‌نظر خود ‌را راحتتر روی نقشه پیدا کنید.',
          disableBeacon: true,
          placement: 'left',
        },
        {
          target: '.demo-container',
          content:
            'از اینکه با صبوری و آرامش این آموزش را دنبال کردید سپاس‌گزاریم.',
          disableBeacon: true,
          placement: 'center',
          floaterProps: { hideArrow: true },
          locale: { close: 'بستن' },
          styles: {
            tooltip: {
              flexDirection: 'column',
              padding: 30,
            },
            options: {
              width: 337,
            },
            buttonNext: {
              backgroundColor: 'unset',
              backgroundImage: 'unset',
              backgroundSize: 'unset',
              backgroundRepeat: 'unset',
              backgroundPosition: 'unset',
              width: 91,
              borderColor: 'white',
              borderStyle: 'solid',
              borderWidth: 3,
              borderRadius: 20,
              margin: '0 10px',
            },
          },
        },
      ],
      runTour: false,
    };

    this.addMarker = this.addMarker.bind(this);
    this.setMarker = this.setMarker.bind(this);
    this.setMap = this.setMap.bind(this);
    this.openSearch = this.openSearch.bind(this);
    this.doSearch = this.doSearch.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.showOnMap = this.showOnMap.bind(this);
    this.getBounds = this.getBounds.bind(this);
    this.showTour = this.showTour.bind(this);
    this.handleJoyrideCallback = this.handleJoyrideCallback.bind(this);
  }

  componentDidMount() {
    // make show tour button in header visible
    // document.querySelector('#show-demo-tour').style.visibility = 'visible';
  }

  addMarker(
    address,
    updateAddress,
    updateLocation,
    apiKey,
    markers,
    updateMarkers,
    centerMarker,
    centerCoordinate,
    updateCenterMarker,
    updateName,
    setMessage
  ) {
    let tempCenterMarker = [];

    if (
      centerMarker === null ||
      centerMarker === [] ||
      centerMarker.length === 0
    ) {
      tempCenterMarker.push(
        <div
          key={Math.random()}
          className="marker-container"
          onDoubleClick={() => {
            this.setMarker(
              address,
              updateAddress,
              updateLocation,
              apiKey,
              markers,
              updateMarkers,
              centerMarker,
              centerCoordinate,
              updateCenterMarker,
              updateName,
              setMessage
            );
          }}
        ></div>
      );

      updateCenterMarker(tempCenterMarker);
    } else {
      updateCenterMarker([]);
    }
  }

  setMap(
    map,
    routes,
    location,
    updateLocation,
    centerCoordinate,
    updateCenterCoordinate
  ) {
    // let routes = this.state.routes;
    // let updateLocation = this.state.updateLocation;
    // let centerCoordinate = this.state.centerCoordinate;
    // let updateCenterCoordinate = this.state.updateCenterCoordinate;
    let _this = this;
    let center = map.getCenter();
    if (JSON.stringify(center) === JSON.stringify(lastCenter)) {
    } else {
      lastCenter = center;
      updateCenterCoordinate(center);
      updateLocation(center);
      _this.setState({
        map,
        routes,
      });
    }
  }

  setMarker(
    address,
    updateAddress,
    updateLocation,
    apiKey,
    markers,
    updateMarkers,
    centerMarker,
    centerCoordinate,
    updateCenterMarker,
    updateName,
    setMessage
  ) {
    if (address.length > 0) {
      setMessage({
        text: 'ابتدا نشانی قبلی را تایید نمایید.',
        type: 'validation',
      });
      return;
    } else {
      setMessage({
        text: 'پیام‌های شما اینجا نمایش داده می‌شود.',
        type: 'default',
      });
    }

    let tempMarkers = [...markers];

    tempMarkers.push([
      centerCoordinate.lng || 51.38,
      centerCoordinate.lat || 35.7,
    ]);

    setMessage({ text: 'لطفا کمی صبور باشید...', type: 'loading' });
    axios({
      method: 'GET',
      url: URL.fastReverse,
      headers: {
        'x-api-key': apiKey,
      },
      params: {
        lat: centerCoordinate.lat || 35.7,
        lon: centerCoordinate.lng || 51.38,
      },
    })
      .then(function (res) {
        setMessage({
          text: 'پیام‌های شما اینجا نمایش داده می‌شود.',
          type: 'default',
        });
        updateAddress(res.data.address);
        updateLocation({
          lat: centerCoordinate.lat || 35.7,
          lng: centerCoordinate.lng || 51.38,
        });
        updateName(res.data.last);
      })
      .catch(function (err) {
        setMessage({ text: 'لطفا دوباره تلاش کنید', type: 'not-found' });
        console.error(err);
      });

    updateCenterMarker([]);
    updateMarkers(tempMarkers);
  }

  openSearch(
    e,
    address,
    centerCoordinate,
    updateCenterCoordinate,
    updateAddress,
    updateLocation,
    apiKey,
    updateMarkers,
    centerMarker,
    updateCenterMarker,
    updateName,
    markers,
    setMessage
  ) {
    var _this = this;
    let searchInput = [];

    if (
      _this.state.searchInput === [] ||
      _this.state.searchInput === null ||
      _this.state.searchInput.length === 0
    ) {
      searchInput.push(
        <Input
          className="search-input"
          placeholder="جستجو"
          onInput={(e) =>
            this.doSearch(
              e,
              address,
              updateCenterCoordinate,
              updateAddress,
              updateLocation,
              apiKey,
              updateMarkers,
              centerMarker,
              centerCoordinate,
              updateCenterMarker,
              updateName,
              markers,
              setMessage
            )
          }
          onClick={(e) =>
            this.doSearch(
              e,
              address,
              updateCenterCoordinate,
              updateAddress,
              updateLocation,
              apiKey,
              updateMarkers,
              centerMarker,
              centerCoordinate,
              updateCenterMarker,
              updateName,
              markers,
              setMessage
            )
          }
        />
      );

      _this.setState({ searchInput });
    } else {
      _this.setState({ searchInput: null, searchResult: null });
    }
  }

  doSearch(
    e,
    address,
    updateCenterCoordinate,
    updateAddress,
    updateLocation,
    apiKey,
    updateMarkers,
    centerMarker,
    centerCoordinate,
    updateCenterMarker,
    updateName,
    markers,
    setMessage
  ) {
    let _this = this;

    if (_this.state.searchTimeOut !== undefined)
      clearTimeout(_this.state.searchTimeOut);
    _this.state.searchTimeOut = setTimeout(
      ((value) => {
        setMessage({ text: 'لطفا کمی صبور باشید...', type: 'loading' });
        axios({
          method: 'GET',
          url: URL.autoComplete,
          headers: {
            'x-api-key': apiKey,
          },
          params: {
            text: value,
            $select: 'nearby',
            lat: _this.state.map.getCenter().lat || 35.7,
            lon: _this.state.map.getCenter().lng || 51.38,
          },
        })
          .then(function (res) {
            setMessage({
              text: 'پیام‌های شما اینجا نمایش داده می‌شود.',
              type: 'default',
            });
            let searchResult = [];
            res.data.value.forEach((element) => {
              searchResult.push(
                <span
                  className=""
                  onClick={() =>
                    _this.showOnMap(
                      address,
                      element.geom.coordinates,
                      updateCenterCoordinate,
                      updateAddress,
                      updateLocation,
                      apiKey,
                      updateMarkers,
                      centerMarker,
                      centerCoordinate,
                      updateCenterMarker,
                      updateName,
                      markers,
                      setMessage
                    )
                  }
                >
                  {element.address}, {element.title}
                </span>
              );
            });
            _this.setState({ searchResult });
          })
          .catch(function (err) {
            setMessage({ text: 'لطفا دوباره تلاش کنید', type: 'not-found' });
            console.error(err);
          });
      }).bind(null, e.target.value),
      500
    );
  }

  showOnMap(
    address,
    coordinates,
    updateCenterCoordinate,
    updateAddress,
    updateLocation,
    apiKey,
    updateMarkers,
    centerMarker,
    centerCoordinate,
    updateCenterMarker,
    updateName,
    markers,
    setMessage
  ) {
    updateCenterCoordinate({ lng: coordinates[0], lat: coordinates[1] });
    updateLocation({ lng: coordinates[0], lat: coordinates[1] });
    let _this = this;

    _this.addMarker(
      address,
      updateAddress,
      updateLocation,
      apiKey,
      markers,
      updateMarkers,
      [],
      centerCoordinate,
      updateCenterMarker,
      updateName,
      setMessage
    );

    _this.setState({ searchResult: null });
  }

  handleClick(e) {
    if (e.target.classList[0].includes('in')) this.state.map.zoomIn();
    else this.state.map.zoomOut();
  }

  getBounds(markers) {
    var bounds = new mapboxgl.LngLatBounds();

    if (markers.length > 0)
      markers.forEach(function (feature) {
        bounds.extend(feature);
      });
    else bounds.extend([51.38, 35.7]);

    this.state.map.fitBounds(bounds, {
      padding: { top: 20, bottom: 20, left: 20, right: 20 },
    });
  }

  showTour() {
    this.setState({ runTour: true });
  }

  handleJoyrideCallback(data = CallBackProps) {
    const { index, status, type } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    const floater = document.querySelector(
      '[id^="react-joyride-step-"] .__floater__body'
    );
    // const floater = document.querySelector('[id^="react-joyride-step-"]')

    if (type === 'tooltip' && floater) {
      setTimeout(() => {
        floater.style.visibility = 'visible';
      }, 200);
    }

    if (index === 0 && type === 'step:before') {
      let buttons = [
        ...document.querySelectorAll('.react-joyride__tooltip button'),
      ].slice(0, -1);
      buttons.forEach((btn, i) => {
        btn.classList.add('btn-secondary', 'animation-swipe');
        if (i === 0) {
          btn.dataset.direction = 'left';
          btn.style.setProperty('--animation-background', '#eebb00');
        }
        if (i === 1) {
          btn.dataset.direction = 'right';
        }
        btn.style.height = 'unset';
        btn.style.zIndex = '0';
      });
    }

    if (index === 1 && type === 'step:after') {
      document.querySelector('.icon-remark').click();
    }

    if (index === 2 && type === 'step:after') {
      document.querySelector('.icon-setmark').click();
    }

    if (index === 7 && type === 'step:after') {
      document.querySelector('.main-bar .submit .btn-primary').click();
    }

    if (finishedStatuses.includes(status)) {
      this.setState({ runTour: false });
    }
  }

  render() {
    return (
      <MapDemoContext.Consumer>
        {({
          address,
          updateAddress,
          routes,
          location,
          updateLocation,
          markers,
          updateMarkers,
          centerMarker,
          updateCenterMarker,
          centerCoordinate,
          updateCenterCoordinate,
          name,
          updateName,
          apiKey,
          selectedSourceIndex,
          destinations,
          demo,
          message,
          setMessage,
        }) => {
          this.location = location;

          let routeLayer = [];
          if (Object.entries(routes).length > 0) {
            routes.forEach((r, idx) => {
              // this.state.lineColors.push(r.features[0].properties.stroke);
              routeLayer.push(
                <Mapir.GeoJSONLayer
                  data={r}
                  key={`${idx}`}
                  id={`${idx}`}
                  linePaint={{
                    'line-color': r.features[0].properties.stroke,
                    'line-width': 5,
                  }}
                  lineOnClick={(e) => {
                    let popup = [];
                    popup.push(
                      <Mapir.Popup
                        coordinates={[e.lngLat.lng, e.lngLat.lat]}
                        onClick={() => this.setState({ popup: null })}
                      >
                        {r.features[0].properties.title}
                      </Mapir.Popup>
                    );
                    this.setState({ popup });
                  }}
                  lineOnMouseEnter={(e) => {
                    this.state.map.setPaintProperty(
                      `${idx}-line`,
                      'line-color',
                      '#FF0062'
                    );

                    // e.layer.openPopup();
                    // let _lineColors = Array(Object.entries(routes).length).fill(r.features[0].properties.stroke);
                    // _lineColors[idx] = "#E71566"
                    // this.setState({ lineColors: _lineColors });
                  }}
                  lineOnMouseLeave={() => {
                    this.state.map.setPaintProperty(
                      `${idx}-line`,
                      'line-color',
                      r.features[0].properties.stroke
                    );
                    // let _lineColors = Array(Object.entries(routes).length).fill(r.features[0].properties.stroke);
                    // this.setState({ lineColors: _lineColors });
                  }}
                />
              );
            });
            if (!flag) {
              this.getBounds(markers);
              flag = true;
            }
          } else {
            flag = false;
          }

          return (
            <div className="main-demo">
              <Joyride
                callback={this.handleJoyrideCallback}
                steps={this.state.steps}
                run={this.state.runTour}
                disableOverlay={true}
                disableScrolling={true}
                hideBackButton={true}
                showSkipButton={true}
                locale={{ close: 'ادامه', skip: 'بستن آموزش' }}
                styles={{
                  tooltip: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: 14,
                    padding: 0,
                    borderRadius: 10,
                  },
                  buttonClose: {
                    display: 'none',
                  },
                  buttonNext: {
                    backgroundColor: 'unset',
                    backgroundImage: `url(${skip})`,
                    backgroundSize: '10px 10px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'left',
                    width: 70,
                    fontSize: 14,
                  },
                  buttonSkip: {
                    backgroundImage: `url(${close})`,
                    backgroundSize: '10px 10px',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'left',
                    width: 110,
                    padding: 0,
                    margin: 8,
                  },
                  tooltipFooter: {
                    flexDirection: 'row-reverse',
                    marginTop: 0,
                  },
                  options: {
                    arrowColor: 'rgba(112, 112, 112, 0.8)',
                    backgroundColor: 'rgba(112, 112, 112, 0.8)',
                    primaryColor: '#000',
                    textColor: '#FFF',
                    width: 571,
                    height: '68px',
                  },
                }}
              />
              <div className="map-demo">
                <div className="map-toolbar">
                  <div className="map-toolbar-top">
                    <div
                      className="icon-remark"
                      onClick={() =>
                        this.addMarker(
                          address,
                          updateAddress,
                          updateLocation,
                          apiKey,
                          markers,
                          updateMarkers,
                          centerMarker,
                          centerCoordinate,
                          updateCenterMarker,
                          updateName,
                          setMessage
                        )
                      }
                    ></div>
                    <div
                      className="icon-setmark"
                      onClick={() =>
                        this.setMarker(
                          address,
                          updateAddress,
                          updateLocation,
                          apiKey,
                          markers,
                          updateMarkers,
                          centerMarker,
                          centerCoordinate,
                          updateCenterMarker,
                          updateName,
                          setMessage
                        )
                      }
                    ></div>
                    <div
                      className="icon-search"
                      onClick={(e) =>
                        this.openSearch(
                          e,
                          address,
                          centerCoordinate,
                          updateCenterCoordinate,
                          updateAddress,
                          updateLocation,
                          apiKey,
                          updateMarkers,
                          centerMarker,
                          updateCenterMarker,
                          updateName,
                          markers,
                          setMessage
                        )
                      }
                    ></div>
                  </div>
                  <div className="map-toolbar-bottom">
                    <div
                      className="icon-zoom-in"
                      onClick={this.handleClick}
                    ></div>
                    <div
                      className="icon-zoom-out"
                      onClick={this.handleClick}
                    ></div>
                  </div>
                </div>
                {this.state.searchInput}
                <div className="result-container">
                  {this.state.searchResult}
                </div>

                <Mapir
                  center={[
                    centerCoordinate.lng || 51.38,
                    centerCoordinate.lat || 35.7,
                  ]}
                  Map={Map}
                  apiKey={mapApiKey}
                  zoom={this.state.zoom}
                  onStyleData={(map) => {
                    this.setMap(
                      map,
                      routes,
                      location,
                      updateLocation,
                      centerCoordinate,
                      updateCenterCoordinate
                    );
                  }}
                  onMoveEnd={(map) => {
                    this.setMap(
                      map,
                      routes,
                      location,
                      updateLocation,
                      centerCoordinate,
                      updateCenterCoordinate
                    );
                  }}
                  containerStyle={{
                    height: '100%',
                    width: '62%',
                  }}
                  userLocation
                >
                  {demo === 'Vrp' ? (
                    <Mapir.Marker
                      Image={defaultMarker}
                      coordinates={[51.422681, 35.732544]}
                      anchor="center"
                      draggable={true}
                      className="source-marker"
                    ></Mapir.Marker>
                  ) : (
                    ''
                  )}
                  {centerMarker}
                  {markers.map((c, idx) => (
                    <Mapir.Marker
                      key={idx}
                      Image={
                        idx === selectedSourceIndex
                          ? defaultMarker
                          : defaultMarkerBlue
                      }
                      coordinates={c}
                      anchor="center"
                      onClick={(e) => {
                        let popup = [];
                        popup.push(
                          <Mapir.Popup
                            coordinates={c}
                            onClick={() => {
                              this.setState({ popup: null });
                            }}
                            offset={{
                              bottom: [0, -15],
                            }}
                            key={idx}
                          >
                            {idx in destinations ? destinations[idx].name : ''}
                          </Mapir.Popup>
                        );
                        this.setState({ popup });
                      }}
                      draggable={true}
                      className={`${
                        idx === selectedSourceIndex ? 'red-text' : ''
                      }`}
                    ></Mapir.Marker>
                  ))}

                  {routeLayer}
                  {this.state.popup}
                </Mapir>
                <Sidebar />
              </div>
              <AddressBar location={location} address={address} />
              <Button
                id="show-demo-tour"
                secondary
                color="navy"
                onClick={this.showTour}
              >
                مشاهده آموزش
              </Button>
              <MessageBox message={message.text} type={message.type} />
            </div>
          );
        }}
      </MapDemoContext.Consumer>
    );
  }
}
